import { useLocation } from "react-router-dom";

export const useQueryString = (queryString: string): string | null => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  return query.get(queryString);
};
